<form class="popover-body" [formGroup]="form" h3ScrollEnabler>
  <mat-form-field>
    <mat-label>Error type</mat-label>
    <mat-select formControlName="errorTag">
      @for (possibleErrorTag of possibleErrorTags; track possibleErrorTag) {
        <mat-option [value]="possibleErrorTag">
          {{ possibleErrorTag | titlecase }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field>
    <mat-label>Comments</mat-label>
    <textarea matInput formControlName="comment"></textarea>
  </mat-form-field>
  <div class="popover-action">
    <button
      mat-button
      type="button"
      color="primary"
      [disabled]="form.invalid"
      (click)="saveFeedback()"
    >
      SAVE
    </button>
  </div>
</form>
